import { Phone, Mail, MapPin, ArrowUp } from "lucide-react";
import { Logo } from "./Logo";

const contact = [
  { icon: Phone, label: "(352) 258-7381", id: "phone", href: "tel:+13522587381" },
  { icon: Mail, label: "jamesfamilyhomeimprovement@gmail.com", id: "email", href: "mailto:jamesfamilyhomeimprovement@gmail.com" },
  { icon: MapPin, label: "Serving all of North & Central Florida", id: "area" },
];

export const Footer = () => (
  <footer className="grain relative overflow-hidden bg-[#1A1714] text-[#FAF9F5] pt-24 pb-10" data-testid="site-footer">
    <div className="mx-auto max-w-[1400px] px-5 sm:px-8 lg:px-12">
      <div className="grid gap-12 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <Logo dark />
          <p className="mt-6 max-w-sm text-sm text-[#BDB5A9] leading-relaxed">
            Family-owned home improvement led by Harold James — remodels, repairs and honest craftsmanship across North &amp; Central Florida.
          </p>
          <a href="#quote" data-testid="footer-quote-button"
            className="mt-8 inline-flex rounded-full bg-[#C85A32] px-6 py-3 text-sm font-semibold text-white transition-colors duration-300 hover:bg-[#FAF9F5] hover:text-[#1E1B18]">
            Request a Free Quote
          </a>
        </div>
        <div className="lg:col-span-3">
          <p className="font-mono-d text-[11px] uppercase tracking-[0.25em] text-[#BDB5A9]">Contact</p>
          <ul className="mt-5 space-y-4">
            {contact.map((c) => (
              <li key={c.id} className="flex items-start gap-3 text-sm break-all sm:break-normal" data-testid={`footer-contact-${c.id}`}>
                <c.icon className="h-4 w-4 mt-0.5 shrink-0 text-[#D49A46]" />
                {c.href ? <a href={c.href} className="transition-colors hover:text-[#E8A27F]">{c.label}</a> : c.label}
              </li>
            ))}
          </ul>
        </div>
        <div className="lg:col-span-4">
          <p className="font-mono-d text-[11px] uppercase tracking-[0.25em] text-[#BDB5A9]">Explore</p>
          <ul className="mt-5 grid grid-cols-2 gap-3 text-sm">
            {["services", "story", "projects", "process", "quote"].map((id) => (
              <li key={id}><a href={`#${id}`} data-testid={`footer-link-${id}`} className="capitalize text-[#E8E2D8] transition-colors hover:text-[#E8A27F]">{id === "quote" ? "Get a quote" : id}</a></li>
            ))}
          </ul>
        </div>
      </div>
      <p aria-hidden className="mt-20 select-none font-serif-d font-semibold italic leading-[0.8] tracking-tight text-[#2A251F] text-[17vw] lg:text-[16vw] whitespace-nowrap">
        James Family
      </p>
      <div className="mt-8 flex flex-col gap-4 border-t border-[#332D27] pt-6 text-xs text-[#BDB5A9] sm:flex-row sm:items-center sm:justify-between">
        <p>© 2026 James Family Home Improvement LLC. All rights reserved. · License # L25000387022</p>
        <a href="#top" data-testid="footer-back-to-top" className="inline-flex items-center gap-2 hover:text-[#FAF9F5]">Back to top <ArrowUp className="h-3 w-3" /></a>
      </div>
    </div>
  </footer>
);
